import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { 
  Phone, MapPin, Mail, Clock, Send,
  CheckCircle, ChevronDown 
} from 'lucide-react';

const ContactPage = () => {
  const [formStatus, setFormStatus] = useState('idle'); // idle | submitting | success

 const handleSubmit = (e) => {
  e.preventDefault();
  setFormStatus('submitting');

  const formData = {
    firstName: e.target[0].value,
    lastName: e.target[1].value,
    email: e.target[2].value,
    phone: e.target[3].value,
    service: e.target[4].value,
    message: e.target[5].value,
    date: new Date().toLocaleString(),
    to_email: "info@palloshigalabau.de" // must be valid
  };

  emailjs.send(
    'service_x3if0m8',    // your EmailJS service ID
    'template_crqm0un',   // your EmailJS template ID
    formData,
    'I-w6NXXGBwAtD2oe9'  // your EmailJS public key
  )
  .then(() => setFormStatus('success'))
  .catch(() => {
    alert('Fehler beim Senden! Bitte versuchen Sie es erneut.');
    setFormStatus('idle');
  });
};


  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">

      {/* HERO SECTION */}
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden bg-slate-900">
        <img
          src="https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=2560&auto=format&fit=crop"
          alt="Garten Landschaftsbau"
          className="absolute inset-0 w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/40 to-slate-50"></div>
        <div className="relative z-10 text-center px-4">
          <span className="text-emerald-400 font-bold uppercase tracking-widest text-sm mb-4 block">
            Kontakt
          </span>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6">
            Ihr Projekt beginnt mit  
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-300">
              einem Gespräch
            </span>
          </h1>
          <p className="text-lg text-slate-200 max-w-2xl mx-auto">
            Kontaktieren Sie Palloshigalabau für eine kostenlose Beratung  
            in Deutschland .
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="relative -mt-32 pb-24">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col lg:flex-row border">

            {/* LEFT INFO */}
            <div className="bg-slate-900 text-white p-10 lg:p-16 lg:w-[40%] relative">
              <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl -mr-20 -mt-20"></div>
              <h3 className="text-3xl font-bold mb-6">Kontaktinformationen</h3>
              <p className="text-slate-400 mb-10 text-lg">
                Schreiben Sie uns oder rufen Sie direkt an –  
                wir beraten Sie persönlich und unverbindlich.
              </p>

              <div className="space-y-8">
                <div className="flex gap-5">
                  <Phone className="text-emerald-400 mt-1" />
                  <div>
                    <p className="font-bold">Telefon</p>
                    <a href="tel:+4915735547097" className="text-slate-400 hover:text-emerald-300">
                      +49 15735547097
                    </a>
                  </div>
                </div>

                <div className="flex gap-5">
                  <Mail className="text-emerald-400 mt-1" />
                  <div>
                    <p className="font-bold">E-Mail</p>
                    <a href="mailto:info@palloshigalabau.de" className="text-slate-400 hover:text-emerald-300">
                      info@palloshigalabau.de
                    </a>
                  </div>
                </div>

                <div className="flex gap-5">
                  <MapPin className="text-emerald-400 mt-1" />
                  <div>
                    <p className="font-bold">Einsatzgebiet</p>
                    <p className="text-slate-400">Deutschland </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 bg-white/5 p-6 rounded-2xl">
                <div className="flex gap-4">
                  <Clock className="text-emerald-400 mt-1" />
                  <div>
                    <p className="font-bold mb-1">Öffnungszeiten</p>
                    <p className="text-slate-400 text-sm">Mo – Fr: 08:00 – 18:00 Uhr</p>
                    <p className="text-slate-400 text-sm">Sa: Nach Vereinbarung</p>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="p-10 lg:p-16 lg:w-[60%]">
              {formStatus === 'success' ? (
                <div className="flex flex-col items-center justify-center text-center py-20">
                  <CheckCircle className="text-emerald-600 w-20 h-20 mb-6" />
                  <h3 className="text-3xl font-bold mb-4">Anfrage gesendet</h3>
                  <p className="text-slate-600 text-lg max-w-md">
                    Vielen Dank für Ihre Nachricht.  
                    Wir melden uns schnellstmöglich bei Ihnen.
                  </p>
                  <button
                    onClick={() => setFormStatus('idle')}
                    className="mt-10 px-8 py-3 border-2 rounded-lg font-bold hover:border-emerald-500 hover:text-emerald-600 transition"
                  >
                    Neue Anfrage senden
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <input required placeholder="Vorname" className="input" />
                    <input required placeholder="Nachname" className="input" />
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <input required type="email" placeholder="E-Mail-Adresse" className="input" />
                    <input type="tel" placeholder="Telefonnummer" className="input" />
                  </div>

                  <div className="relative">
                    <select className="input appearance-none">
                      <option>Gartenpflege</option>
                      <option>Baumfällung</option>
                      <option>Holzterrassen</option>
                      <option>Pflasterarbeiten</option>
                      <option>Zaunbau</option>
                      <option>Sonstiges</option>
                    </select>
                    <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400" />
                  </div>

                  <textarea rows="4" required placeholder="Beschreiben Sie Ihr Projekt..." className="input resize-none" />

                  <button
                    type="submit"
                    disabled={formStatus === 'submitting'}
                    className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 rounded-lg flex items-center justify-center gap-2"
                  >
                    {formStatus === 'submitting' ? 'Senden…' : 'Anfrage senden'}
                    {formStatus !== 'submitting' && <Send size={20} />}
                  </button>
                </form>
              )}
            </div>

          </div>
        </div>
      </section>

      {/* STYLES */}
      <style>{`
        .input {
          width: 100%;
          padding: 0.75rem 1rem;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 0.5rem;
          outline: none;
        }
        .input:focus {
          border-color: #10b981;
          box-shadow: 0 0 0 4px rgba(16,185,129,0.1);
        }
      `}</style>
    </div>
  );
};

export default ContactPage;
